import { render, staticRenderFns } from "./RirekishoCreateDateCard.vue?vue&type=template&id=9710c7fa&scoped=true"
import script from "./RirekishoCreateDateCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./RirekishoCreateDateCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RirekishoCreateDateCard.vue?vue&type=style&index=0&id=9710c7fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9710c7fa",
  null
  
)

export default component.exports